module.exports = __webpack_public_path__ + "img/inspiring_background_mobile@2x.2a47665.webp";